import { SectionType } from '../types';

/** Blockens namn i Studio. Samma ord i listan, i förhandsvisningen och på knapparna. */
export const SECTION_LABELS: Record<SectionType, string> = {
    HERO: 'Toppbild',
    FEATURES: 'Fördelar',
    CONTENT: 'Text och bild',
    CONTACT: 'Kontakt',
    PRODUCTS: 'Bästsäljare',
    PRODUCT_GRID: 'Alla produkter',
    REVIEWS: 'Omdömen',
    MEDIA: 'Bildrulle',
};

export const sectionLabel = (type: string) => SECTION_LABELS[type as SectionType] ?? type;
